import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeCostGroupLinkService from '../../../Services/OfficeCostGroupLinkService';
import OfficeCostGroupLinkItem from '../../../Domain/OfficeCostGroupLinkItem';

export default class EditOfficeCostGroupLinkWindowDescription {
  static titleForEdit = 'Edit Office Cost Group Link';
  static itemType = OfficeCostGroupLinkItem;
  static finishButtonLabel = 'Save';
  static messageOnSuccess = 'Office cost group link has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: only these two fields are posted back.
  // MUST return the promise (wizard contract).
  static serviceFunction = (edited) =>
    OfficeCostGroupLinkService.EditOfficeCostGroupLink({
      OfficeCostGroupLinkId: edited.OfficeCostGroupLinkId,
      CalculateWeeklyAverage: edited.CalculateWeeklyAverage === true || edited.CalculateWeeklyAverage === 'true',
    });

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CostGroupLabel',
          label: 'Cost Group',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CalculateWeeklyAverage',
          label: 'Calculate Weekly Average',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.forRequiredBoolField,
        },
      ],
    },
  ];
}
